// assets/reorder-master-auto.js (Reorder Master: hide prices only)
(function () {
  if (window.__wrwReorderMasterHidePrices) return;
  window.__wrwReorderMasterHidePrices = true;

  const DEBUG = false;
  const log = (...args) => { if (DEBUG) console.log('[WRW ReorderMaster]', ...args); };

  function injectHidePriceCSS() {
    if (document.getElementById('wrw-rm-hide-price-styles')) return;
    const style = document.createElement('style');
    style.id = 'wrw-rm-hide-price-styles';
    style.textContent = `
      #hulkapp_reorder_master [class*='price' i],
      #hulkapp_reorder_master [id*='price' i],
      #hulkapp_reorder_master [data-price],
      #hulkapp_reorder_master .money,
      #hulkapp_reorder_master .Money,
      #hulkapp_reorder_master .hulk_price,
      #hulkapp_reorder_master .hulk-price,
      #hulkapp_reorder_master .hulk_cart_item_price,
      #hulkapp_reorder_master .hulk_cart__item_price,
      #hulkapp_reorder_master .hulk_cart_total,
      #hulkapp_reorder_master .hulk_cart__total,
      #hulkapp_reorder_master .hulk_subtotal,
      #hulkapp_reorder_master .hulk_sub_total,
      #hulkapp_reorder_master .hulk_total,
      #hulkapp_reorder_master .hulk_total_price,
      #hulkapp_reorder_master .hulk_total-price,
      #hulkapp_reorder_master [class*='fee' i],
      #hulkapp_reorder_master [id*='fee' i],
      #hulkapp_reorder_master [data-fee] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function hideFeeLineItems() {
    const modal = document.getElementById('hulkapp_reorder_master');
    if (!modal) return;
    const lineItems = modal.querySelectorAll('.hulk_line_item');
    lineItems.forEach(item => {
      const text = item.innerText || item.textContent || '';
      if (text.toLowerCase().includes('fee')) {
        item.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function overrideModalHeaderFont() {
    const modal = document.getElementById('hulkapp_reorder_master');
    if (!modal) return;
    const h2 = modal.querySelector('.hulk_modal-header h2');
    if (!h2) return;
    h2.style.setProperty('font-family', "'Open Sans', sans-serif", 'important');
    h2.style.setProperty('font-weight', '600', 'important');
  }

  injectHidePriceCSS();

  const observer = new MutationObserver(() => {
    if (document.getElementById('hulkapp_reorder_master')) {
      injectHidePriceCSS();
      hideFeeLineItems();
      overrideModalHeaderFont();
    }
  });

  try {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
